import type { OperationCategoryChange } from '../../model/bank-operation.js';
import type { OperationCategoryBodyDto } from '../dto/operation-category-body.dto.js';

export const toOperationCategoryBody = (
  change: OperationCategoryChange,
): OperationCategoryBodyDto => ({
  categoryId: change.categoryId,
  scope: change.scope,
});
